import { render, staticRenderFns } from "./Recalculation.vue?vue&type=template&id=4323486a&scoped=true&"
import script from "./Recalculation.vue?vue&type=script&lang=js&"
export * from "./Recalculation.vue?vue&type=script&lang=js&"
import style0 from "./Recalculation.vue?vue&type=style&index=0&id=4323486a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323486a",
  null
  
)

export default component.exports